import React from 'react';
import './profileIcon.styles.scss';
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectUserName } from "../../redux/user/user.selector";

const ProfileIcon = ({ userName }) => {

    const getFirstLettersOfName = () => {
        const str = userName;
        if (str) {
            let arrayOfFirstLetters = str.match(/\b(\w)/g);
            let iconText = arrayOfFirstLetters.slice(0, 2).join('');
            return iconText;
        }
        return ""
    }

    return (
        <div className="profile-container">
            <div className="profile-image">{getFirstLettersOfName()}</div>
        </div>
    );
}

const mapStateToProps = createStructuredSelector({
    userName: selectUserName
})

export default connect(mapStateToProps)(ProfileIcon);